import { Property } from "./interfaces";

export const codPaisResidencia: Property = {
  title: "Código de País de Residencia",
  type: "string",
};
